import { resolveSourceFieldValue } from '@baserow/modules/database/utils/sourceFieldReference'

/**
 * Shared by Barcode/QR Code cell components. Resolves the source field's
 * live value the same way `buttonField.js` resolves a button's URL: prefer
 * `allFieldsInTable` where the render context provides it (selected grid
 * cell, row edit modal), falling back to the field store for contexts that
 * only pass row + field (functional grid cells, cards).
 */
export default {
  computed: {
    resolvedSourceValue() {
      const fields =
        this.allFieldsInTable?.length > 0
          ? this.allFieldsInTable
          : this.$store.getters['field/getAll']
      return resolveSourceFieldValue(
        this.$registry,
        this.field,
        this.row,
        fields
      )
    },
  },
}
